import { useState } from "react";
import { Button } from "@/components/ui/button";

interface RunTestButtonProps {
  label: string;
  /** Rejects on failure; the parent already shows the error, so we only re-enable the button. */
  onRun: () => Promise<unknown>;
}

/** Starts one test straight away (no confirm: a single model is cheap). */
const RunTestButton = ({ label, onRun }: RunTestButtonProps) => {
  const [pending, setPending] = useState(false);

  async function handleClick() {
    setPending(true);
    try {
      await onRun();
    } catch {
      // Parent shows the error.
    } finally {
      setPending(false);
    }
  }

  return (
    <Button size="sm" variant="outline" disabled={pending} onClick={handleClick}>
      {label}
    </Button>
  );
};

export default RunTestButton;
